import { ensureArray } from './utils/array';
import { isObject } from './utils/object';
import { isSameDay, isWithinInterval, maxTime, minTime } from 'date-fns';

function testBoolean(value) {
	if (typeof value !== 'boolean') {
		return false;
	}

	return value;
}

function testDate(date, value) {
	if (!(value instanceof Date)) {
		return false;
	}

	return isSameDay(date, value);
}

function testFunction(date, value) {
	if (typeof value !== 'function') {
		return;
	}

	return value(date);
}

function isStartDate(date, value) {
	if (value === undefined || !isObject(value) || !('from' in value)) {
		return false;
	}

	return testDate(date, value.from);
}

function isEndDate(date, value) {
	if (value === undefined || !isObject(value) || !('to' in value)) {
		return false;
	}

	return testDate(date, value.to);
}

function testRange(date, value) {
	if (value === undefined || !isObject(value) || (!('from' in value) && !('to' in value))) {
		return false;
	}

	let after = true;
	let before = true;

	if (!value.from && !value.to) {
		return false;
	}

	if (value.from !== undefined) {
		after = isWithinInterval(date, { start: value.from, end: maxTime });
	}

	if (value.to !== undefined) {
		before = isWithinInterval(date, { start: minTime, end: value.to });
	}

	return (before && after);
}

export function testAll(date, dates) {
	let tests = ensureArray(dates);

	let matches = tests.some(value => {
		return (
			testBoolean(value) ||
            testDate(date, value) ||
            testRange(date, value) ||
            testFunction(date, value)
		);
	});

	return {
		matches: matches,
		isEnd: tests.some(value => isEndDate(date, value)),
		isStart: tests.some(value => isStartDate(date, value)),
	};
}
